export const DEFAULT_NOTIFICATION_TIMEOUT_MS = 3000;
export const APP_LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL ?? 'ERROR';
